import {ValueObject} from '@s-ui/domain'

export class ModelsGroupedByBodyTypeDoorsValueObject extends ValueObject {
  /**
   * @param {Array} modelsList
   * */
}
